import React from 'react';
import { Link } from 'react-router-dom';

const LegalNotice = () => {
  return (
    <div className="legal-page">
      <div className="container">
        <div className="legal-header">
          <Link to="/" className="back-to-home">
            ← Volver al inicio
          </Link>
          <h1 className="legal-title">⚖️ Aviso Legal</h1>
          <p className="legal-subtitle">GesOps LLC - Información Legal Importante</p>
        </div>

        <div className="legal-content">
          <section className="legal-section">
            <h2>1. Identificación de la Empresa</h2>
            <div className="company-info">
              <p><strong>Razón Social:</strong> GesOps LLC</p>
              <p><strong>Dirección:</strong> 1420 Celebration Blvd, Suite 101, Celebration, FL 34747, Estados Unidos</p>
              <p><strong>Email:</strong> info@gesops.com</p>
              <p><strong>Sitio Web:</strong> www.gesops.com</p>
              <p><strong>Actividad:</strong> Directorio digital de profesionales y empresas verificadas, y servicios administrativos</p>
            </div>
          </section>

          <section className="legal-section">
            <h2>2. Naturaleza de Nuestros Servicios</h2>
            <div className="important-notice">
              <h3>🚨 AVISO CRÍTICO: GesOps LLC NO Presta Servicios Profesionales</h3>
              <p>
                <strong>GesOps LLC es exclusivamente un directorio tecnológico</strong> que facilita la conexión
                entre personas y empresas que buscan servicios con profesionales y negocios verificados en diversas categorías:
                servicios legales, salud, traducciones, belleza, transporte, catering, entre otros.
              </p>
              <p><strong>NO somos un bufete de abogados, clínica, ni proveedor directo de ninguno de los servicios listados en el directorio.</strong></p>
            </div>
          </section>

          <section className="legal-section">
            <h2>3. Limitaciones Legales Expresas</h2>
            <h3>3.1 Lo que NO hacemos:</h3>
            <ul>
              <li>❌ No proporcionamos asesoría legal de ningún tipo</li>
              <li>❌ No representamos clientes en procedimientos legales</li>
              <li>❌ No preparamos documentos legales</li>
              <li>❌ No interpretamos leyes o regulaciones</li>
              <li>❌ No garantizamos resultados legales</li>
              <li>❌ No compartimos honorarios con abogados</li>
            </ul>

            <h3>3.2 Lo que SÍ hacemos:</h3>
            <ul>
              <li>✅ Mantenemos un directorio de profesionales y empresas verificadas</li>
              <li>✅ Facilitamos el contacto directo con profesionales de múltiples categorías</li>
              <li>✅ Verificamos credenciales y datos básicos de los listados</li>
              <li>✅ Proporcionamos información de contacto actualizada</li>
              <li>✅ Ofrecemos servicios administrativos opcionales</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>4. Relación con los Profesionales y Empresas Listados</h2>
            <p>
              Los profesionales y empresas en nuestro directorio son <strong>independientes</strong>. GesOps LLC:
            </p>
            <ul>
              <li>No controla ni supervisa la práctica o actividad de los listados</li>
              <li>No es responsable por la calidad de sus servicios</li>
              <li>No participa en la relación proveedor-cliente</li>
              <li>No recibe comisiones por servicios prestados o resultados obtenidos</li>
              <li>Solo facilita el contacto inicial</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>5. Modalidad de Atención</h2>
            <div className="service-mode">
              <h3>🌐 Servicios 100% Virtuales</h3>
              <p>
                <strong>GesOps LLC opera exclusivamente de forma virtual.</strong> Nuestra dirección física 
                es únicamente para correspondencia administrativa.
              </p>
              <p>
                <strong>No atendemos público presencial.</strong> Toda comunicación se realiza por:
              </p>
              <ul>
                <li>📧 Correo electrónico</li>
                <li>💬 WhatsApp Business</li>
                <li>🌐 Formularios web</li>
                <li>📞 Llamadas programadas</li>
              </ul>
            </div>
          </section>

          <section className="legal-section">
            <h2>6. Verificación de Profesionales y Empresas</h2>
            <p>
              Realizamos verificaciones básicas de los profesionales y empresas en nuestro directorio, incluyendo:
            </p>
            <ul>
              <li>Credenciales o licencias profesionales cuando aplique</li>
              <li>Información de contacto válida</li>
              <li>Autorización para aparecer en el directorio</li>
            </ul>
            <p>
              <strong>Sin embargo, no garantizamos:</strong> La calidad de servicios, experiencia específica,
              resultados obtenidos, o idoneidad para necesidades particulares.
            </p>
          </section>

          <section className="legal-section">
            <h2>7. Responsabilidades del Usuario</h2>
            <p>Al utilizar nuestros servicios, usted reconoce que:</p>
            <ul>
              <li>Debe verificar independientemente las credenciales de cualquier abogado</li>
              <li>Es responsable de evaluar la idoneidad del profesional para su caso</li>
              <li>Debe establecer directamente los términos con el abogado elegido</li>
              <li>GesOps LLC no participa en acuerdos de honorarios</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>8. Limitación de Responsabilidad</h2>
            <p>
              <strong>GesOps LLC no será responsable por:</strong>
            </p>
            <ul>
              <li>Resultados de casos legales</li>
              <li>Mala praxis profesional de abogados listados</li>
              <li>Disputas entre usuarios y abogados</li>
              <li>Pérdidas económicas derivadas de servicios legales</li>
              <li>Decisiones tomadas basándose en información del directorio</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>9. Recomendación Importante</h2>
            <div className="recommendation">
              <p>
                <strong>Siempre consulte directamente con un abogado licenciado</strong> para:
              </p>
              <ul>
                <li>Asesoría legal específica para su situación</li>
                <li>Interpretación de leyes y regulaciones</li>
                <li>Representación en procedimientos legales</li>
                <li>Preparación de documentos legales</li>
                <li>Cualquier decisión legal importante</li>
              </ul>
            </div>
          </section>

          <section className="legal-section">
            <h2>10. Contacto Legal</h2>
            <p>
              Para asuntos legales relacionados con GesOps LLC:
            </p>
            <div className="legal-contact-info">
              <p><strong>GesOps LLC</strong></p>
              <p>📧 Email: info@gesops.com</p>
              <p>🏢 Dirección: 1420 Celebration Blvd, Suite 101, Celebration, FL 34747, Estados Unidos</p>
              <p><strong>Asunto:</strong> "Consulta Legal - [Su nombre]"</p>
            </div>
          </section>

          <div className="legal-disclaimer">
            <p>
              <strong>RECORDATORIO FINAL:</strong> Este aviso legal no constituye asesoría jurídica ni profesional de ningún tipo.
              GesOps LLC es un servicio tecnológico de directorio, no un proveedor directo de los servicios listados.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LegalNotice;
